<div class="flex flex-col w-full h-full bg-gray-100 p-4">
  <div class="bg-white rounded-lg shadow-md p-6">
    <h2 class="text-2xl font-bold text-gray-800 mb-6">Abertura de Turno</h2>
    
    <div class="space-y-4">
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-2">Valor Inicial do Caixa</label>
        <input 
          type="number" 
          step="0.01"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
          placeholder="0,00"
          [(ngModel)]="initialCashValue">
      </div>
      
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-2">Observações</label>
        <textarea 
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
          rows="3"
          placeholder="Observações sobre a abertura do turno"
          [(ngModel)]="observations">
        </textarea>
      </div>
    </div>
    
    <div class="flex justify-end space-x-4 mt-6">
      <button 
        (click)="cancel()"
        class="px-6 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500">
        Cancelar (ESC)
      </button>
      <button 
        (click)="openShift()"
        class="px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500">
        Abrir Turno (F1)
      </button>
    </div>
  </div>
</div>